import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Home', id: 'home' },
    { label: 'Plans', id: 'plans' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'Benefits', id: 'benefits' },
    { label: 'Testimonials', id: 'testimonials' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-28">
        {/* Logo */}
        <button onClick={() => scrollTo('home')} className="cursor-pointer flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/af629f12c2092b190a665b44ca157be0/2a1f8fc981b3a3b70bdb589812f4ada4.jpeg"
            alt="Elite Drainage Services Logo"
            className="h-20 w-auto object-contain rounded-md"
          />
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-sm font-semibold tracking-wide uppercase transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('pricing')}
            className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Get Started
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden text-2xl cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-gray-700 font-semibold text-sm uppercase tracking-wide text-left cursor-pointer hover:text-orange-500 transition-colors whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('pricing')}
            className="bg-orange-500 text-white font-bold text-sm px-5 py-2.5 rounded-full cursor-pointer whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
